import { i as g } from "./settings-DN0V2st5.js";
import { g as x, n as L } from "./settings-DN0V2st5.js";
function b() {
  return typeof window.nosto < "u";
}
function k() {
  return window.nosto;
}
const f = {
  production: "https://connect.nosto.com/",
  staging: "https://connect.staging.nosto.com/",
  local: "https://connect.nosto.com/"
};
function u(o) {
  return f[o ?? "production"];
}
function h({ merchantId: o, env: n, options: e, shopifyInternational: a, scriptLoader: s }) {
  const t = document.querySelector("script[nosto-language], script[nosto-market-id]"), r = String(a?.marketId || ""), i = a?.language || "", l = t?.getAttribute("nosto-language") !== i || t?.getAttribute("nosto-market-id") !== r;
  if (!t || l) {
    const d = document.querySelector("#nosto-sandbox");
    t?.parentNode?.removeChild(t), d?.parentNode?.removeChild(d);
    const c = new URL("/script/shopify/market/nosto.js", u(n));
    c.searchParams.append("merchant", o), c.searchParams.append("market", r), c.searchParams.append("locale", i.toLowerCase());
    const m = {
      ...e?.attributes,
      "nosto-language": i,
      "nosto-market-id": r
    };
    return (s ?? p)(c.toString(), { ...e, attributes: m });
  }
  return Promise.resolve();
}
function y(o) {
  if (o.shopifyInternational)
    return h(o);
  const { merchantId: n, env: e, options: a, scriptLoader: s } = o, t = s ?? p, r = new URL(`/include/${n}`, u(e));
  return t(r.toString(), a);
}
function p(o, n) {
  return new Promise((a, s) => {
    const t = document.createElement("script");
    t.src = o, t.async = !0, t.type = "text/javascript", t.onload = () => a(), t.onerror = () => s(), Object.entries(n?.attributes ?? {}).forEach(([r, i]) => t.setAttribute(r, i)), n?.position === "head" ? document.head.appendChild(t) : document.body.appendChild(t);
  });
}
async function C(o, n, e) {
  if (!window.Nosto?.addSkuToCart)
    throw new Error("Nosto addSkuToCart function is not available");
  await window.Nosto.addSkuToCart(o, n, e);
}
typeof window < "u" && g();
export {
  C as addSkuToCart,
  k as getNostoWindow,
  x as getSettings,
  y as init,
  g as initNostoStub,
  b as isNostoLoaded,
  L as nostojs
};
